import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Box } from '@mui/material';
import { validateIpAddress } from '../IpWhiteList.helper';
import Swal from 'sweetalert2';
import { IPWL } from '../ipWhiteList.classes';

interface IpWhiteListFormProps {
    data?: any;
    onSave: (formData: any) => void;
    onClose: () => void;
}

export const IpWhiteListForm: FC<IpWhiteListFormProps> = ({ data, onSave, onClose }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        id: data?.id || 0,
        ipAddress: data?.ipAddress || '',
        description: data?.description || '',
    });

    useEffect(() => {
        if (data) {
            setFormData({
                id: data.id || 0,
                ipAddress: data.ipAddress || '',
                description: data.description || '',
            });
        }
    }, [data]);

    const handleSubmit = () => {
        if (!formData.ipAddress) {
            Swal.fire({
                icon: 'error',
                title: t('general.error'),
                text: t('ipWhiteList.ipRequired'),
            });
            return;
        }

        if (!validateIpAddress(formData.ipAddress)) {
            Swal.fire({
                icon: 'error',
                title: t('general.error'),
                text: t('ipWhiteList.invalidIp'),
            });
            return;
        }

        onSave(formData);
    };

    return (
        <Box className={IPWL.drawerFormRoot} sx={{ padding: 3, minWidth: 400 }}>
            <h2 className={IPWL.drawerTitle}>{data?.id ? t('ipWhiteList.editIp') : t('ipWhiteList.addNewIp')}</h2>

            <TextField
                className={IPWL.inputTextIpAddress}
                fullWidth
                label={t('ipWhiteList.ipAddress')}
                placeholder={t('ipWhiteList.ipAddressPlaceholder')}
                value={formData.ipAddress}
                onChange={(e) => setFormData({ ...formData, ipAddress: e.target.value })}
                margin="normal"
                required
            />

            <TextField
                className={IPWL.inputTextDescription}
                fullWidth
                label={t('general.description')}
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                margin="normal"
                multiline
                rows={3}
            />

            <Box
                className={IPWL.drawerFooter}
                sx={{ display: 'flex', gap: 2, marginTop: 3, justifyContent: 'flex-end' }}
            >
                <Button className={IPWL.inputButtonCancel} variant="outlined" onClick={onClose}>
                    {t('general.cancel')}
                </Button>
                <Button className={IPWL.inputButtonDrawerSave} variant="contained" onClick={handleSubmit}>
                    {t('general.save')}
                </Button>
            </Box>
        </Box>
    );
};
